import Vue from "vue";

const messageBus = new Vue();
export default messageBus;
